class UserRoleModel {
  id = null;
  name = null;
  display_name = null;
  constructor(userRoleData) {
    if (userRoleData !== undefined) {
      let { id, name, display_name } = userRoleData;
      Object.assign(this, {
        id,
        name,
        display_name
      });
    }
  }
}

export default UserRoleModel;
